import { ReactNode } from 'react';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { insuranceSelector } from '../../../model';
import { useSelector } from 'react-redux';
import { FormProvider, useForm } from 'react-hook-form';
import { InsuranceBrokerForm } from '../../../types';
import { InsuranceAddEditBrokerDialog } from '../../dialogs';
import { ModalsContainer } from 'components/shared/Modals';
import { InsuranceBrokerDetails } from './InsuranceBrokerDetails';
import { InsuranceBrokerEmpty } from './InsuranceBrokerEmpty';
import { ModalsKeys } from 'global';

export const AgentAndPolicyDetails = () => {
  const classes = useStyles();

  const modalsWithKeys: Partial<Record<ModalsKeys, ReactNode>> = {
    [ModalsKeys.InsuranceAddEditBrokerDialog]: <InsuranceAddEditBrokerDialog />,
  };

  const insuranceBroker = useSelector(insuranceSelector.insuranceBroker);

  const form = useForm<InsuranceBrokerForm>({
    defaultValues: {
      companyName: insuranceBroker?.companyName || '',
      contactName: insuranceBroker?.contactName || '',
      contactEmail: insuranceBroker?.contactEmail || '',
      contactPhone: insuranceBroker?.contactPhone || '',
      contactFax: insuranceBroker?.contactFax || '',
      renewalDate: insuranceBroker?.renewalDate || '',
      physicalDamageDeduction: insuranceBroker?.physicalDamageDeduction || undefined,
      liabilityCoverage: insuranceBroker?.liabilityCoverage || undefined,
      productType: insuranceBroker?.productType || '',
    },
  });

  return (
    <Box className={classes.root}>
      <FormProvider {...form}>
        {insuranceBroker ? <InsuranceBrokerDetails /> : <InsuranceBrokerEmpty />}

        <ModalsContainer modalsWithKeys={modalsWithKeys} />
      </FormProvider>
    </Box>
  );
};

const useStyles = makeStyles({
  root: {
    backgroundColor: '#FAFAFA',
    padding: '24px',
  },
});
